import React, { useEffect, useState, memo } from 'react'
import { Card, CardBody, } from 'reactstrap'
import Spinner from '@components/@vuexy/spinner/Fallback-spinner'
import HealthScoreChart from '@screens/EquipmentDetail/components/graphs/HealthScoreChart'
import TempChart from '@screens/EquipmentDetail/components/graphs/TempChart'
import StatusChart from '@screens/EquipmentDetail/components/graphs/StatusChart'
import PressureChart from '@screens/EquipmentDetail/components/graphs/PressureChart'
import CurrentChart from '@screens/EquipmentDetail/components/graphs/CurrentChart'
import VoltageChart from '@screens/EquipmentDetail/components/graphs/VoltageChart'
import PerformanceChart from '@screens/EquipmentDetail/components/graphs/PerformanceChart'
import SuperheatChart from '@screens/EquipmentDetail/components/graphs/SuperheatChart'
import AlertChart from '@screens/EquipmentDetail/components/graphs/AlertChart'
import RPSChart from '@screens/EquipmentDetail/components/graphs/RPSChart'

import { buildChartFromParameter, convertUTCToLocalTime, isUndefined } from '@common/utils'
import {
  TAB,
  CDU_TYPE,
  AIR_TYPE,
  REFRIG_TYPE,
  REFRIG_CDU_TYPE,
  GRAPHPARAMETER, METER_TYPE
} from '@common/constants'

import '@assets/scss/plugins/forms/flatpickr/flatpickr.scss'
import 'flatpickr/dist/themes/light.css'
import PowerChart from '@screens/EquipmentDetail/components/graphs/PowerChart'
import EnergyChart from '@screens/EquipmentDetail/components/graphs/EnergyChart'


const HistoricalGraph = (props) => {
    const [isShowCard, setIsShowCard] = useState(false)
    const [countAlertSeries, setCountAlertSeries] = useState([])
    const [totalAlert, setTotalAlert] = useState(0)

    const [healthScoreChart, setHealthScoreChart] = useState({})
    const [tempChart, setTempChart] = useState({})
    const [statusChart, setStatusChart] = useState({})
    const [pressureChart, setPressureChart] = useState({})
    const [currentChart, setCurrentChart] = useState({})
    const [voltageChart, setVoltageChart] = useState({})
    const [powerChart, setPowerChart] = useState({})
    const [energyChart, setEnergyChart] = useState({})
    const [performanceChart, setPerformanceChart] = useState({})
    const [superheatChart, setSuperHeatChart] = useState({})
    const [alertChart, setAlertChart] = useState({})
    const [rpsChart, setRPSChart] = useState({})

    const [typeCatagoryName, setTypeCatagoryName] = useState(props.typeCatagoryName)

    const [isLoading, setLoading] = useState(true)
    const { parametersArray, parametersDataByGroup } = props.data

    // const GRAPH_GROUP = 'historical-page-chart'


    const setHistoricalDataFromProps = (historicalData) => {
        setLoading(true)

        const [countAlertData, countAlertTotal] = buildAlertSeries(historicalData.alert)
        const chartData = buildChartFromParameter(parametersDataByGroup, null, historicalData, TAB.HISTORICAL)

        setIsShowCard(
            chartData.tempChartData ||
            chartData.statusChartData ||
            chartData.pressureChartData ||
            chartData.currentChartData ||
            chartData.voltageChartData ||
            chartData.powerChartData ||
            chartData.energyChartData ||
            chartData.performanceChartData ||
            chartData.superheatChartData ||
            chartData.rpsChartData ||
            healthScoreData[0].data.length > 0 ||
            avgTempData[0].data.length > 0 ||
            avgStatusData[0].data.length > 0
        )

        setCountAlertSeries(countAlertData)
        setTotalAlert(countAlertTotal)

        //New data to chart
        setHealthScoreChart(chartData.healthChartData)
        setAlertChart(chartData.alertChartData)
        setTempChart(chartData.tempChartData)
        setStatusChart(chartData.statusChartData)
        setPressureChart(chartData.pressureChartData)
        setCurrentChart(chartData.currentChartData)
        setVoltageChart(chartData.voltageChartData)
        setPowerChart(chartData.powerChartData)
        setEnergyChart(chartData.energyChartData)
        setPerformanceChart(chartData.performanceChartData)
        setSuperHeatChart(chartData.superheatChartData)
        setRPSChart(chartData.rpsChartData)

        setLoading(false)
    }


    const buildAlertSeries = (alertData) => {
        let totalAlert = 0
        const alertSeries = [{
            name: 'Alert', type: 'bar', data: []
        }]
        alertData?.map(data => {
            alertSeries[0].data.push({ x: convertUTCToLocalTime(data.read_date), y: data.count_alert })
            if (data.countAlert > 0) totalAlert = totalAlert + data.countAlert
        })
        return [alertSeries, totalAlert]
    }

    useEffect(() => {
        setIsShowCard(false)
        setHistoricalDataFromProps(props.historicalData)
    }, [props.historicaData])

    const renderGraph = () => {
        switch (typeCatagoryName) {
            case REFRIG_TYPE:
                return renderRefrigTypeMode()
            case REFRIG_CDU_TYPE:
                return renderRefrigCduTypeMode()
            case CDU_TYPE:
                return renderCduTypeMode()
            case AIR_TYPE:
                return renderAirTypeMode()
            case METER_TYPE:
                return renderMeterTypeMode()
            default:
                return null
        }
    }

    const renderRefrigTypeMode = () => {
        const { REFRIG_Temp, REFRIG_Status } = GRAPHPARAMETER
        return (
            <Card>
                <CardBody>
                    {healthScoreChart.series[0].data.length > 0
                        && renderDetailChart(healthScoreChart.series, 'Health', healthScoreChart.colors)}
                    {parametersArray.some(item => REFRIG_Temp.includes(item))
                        && !isUndefined(tempChart)
                        && tempChart.series[0].data.length > 0
                        && renderDetailChart(tempChart.series, 'Temp', tempChart.colors)}
                    {parametersArray.some(item => REFRIG_Status.includes(item))
                        && !isUndefined(statusChart)
                        && statusChart.series[0].data.length > 0
                        && renderDetailChart(statusChart.series, 'Status', statusChart.colors)}
                </CardBody>
            </Card>
        )
    }

    const renderRefrigCduTypeMode = () => {
        const { REFRIG_CDU_Temp, REFRIG_CDU_Status, REFRIG_CDU_Performance } = GRAPHPARAMETER

        return (
            isShowCard &&
            <Card>
                <CardBody>
                    {healthScoreChart.series.length > 0 && healthScoreChart.series[0].data.length > 0
                        && renderDetailChart(healthScoreChart.series, 'Health', healthScoreChart.colors)}
                    {parametersArray.some(item => REFRIG_CDU_Temp.includes(item))
                        && !isUndefined(tempChart)
                        && tempChart.series.length > 0 && tempChart.series[0].data.length > 0
                        && renderDetailChart(tempChart.series, 'Temp', tempChart.colors)}
                    {parametersArray.some(item => REFRIG_CDU_Status.includes(item))
                        && !isUndefined(statusChart)
                        && statusChart.series.length > 0 && statusChart.series[0].data.length > 0
                        && renderDetailChart(statusChart.series, 'Status', statusChart.colors)}
                    {parametersArray.some((item) => REFRIG_CDU_Performance.includes(item))
                        && !isUndefined(performanceChart)
                        && performanceChart.series.length > 0 && performanceChart.series[0].data.length > 0
                        && renderDetailChart(performanceChart.series, 'Performance', performanceChart.colors)}
                </CardBody>
            </Card>
        )
    }

    const renderCduTypeMode = () => {
        const {
            CDU_Temp, CDU_Pressure, CDU_Status,
            CDU_Performance, CDU_Current, CDU_Superheat
        } = GRAPHPARAMETER

        return (
            <Card>
                <CardBody>
                    {healthScoreChart.series.length > 0 && healthScoreChart.series[0].data.length > 0
                        && renderDetailChart(healthScoreChart.series, 'Health', healthScoreChart.colors)}
                    {parametersArray.some(item => CDU_Temp.includes(item))
                        && !isUndefined(tempChart)
                        && tempChart.series.length > 0 && tempChart.series[0].data.length > 0
                        && renderDetailChart(tempChart.series, 'Temp', tempChart.colors)}
                    {parametersArray.some(item => CDU_Status.includes(item))
                        && !isUndefined(statusChart)
                        && statusChart.series.length > 0 && statusChart.series[0].data.length > 0
                        && renderDetailChart(statusChart.series, 'Status', statusChart.colors)}
                    {parametersArray.some((item) => CDU_Pressure.includes(item))
                        && !isUndefined(pressureChart)
                        && pressureChart.series.length > 0 && pressureChart.series[0].data.length > 0
                        && renderDetailChart(pressureChart.series, 'Pressure', pressureChart.colors)}
                    {parametersArray.some((item) => CDU_Current.includes(item))
                        && !isUndefined(currentChart)
                        && currentChart.series.length > 0 && currentChart.series[0].data.length > 0
                        && renderDetailChart(currentChart.series, 'Current', currentChart.colors)}
                    {parametersArray.some((item) => CDU_Performance.includes(item))
                        && !isUndefined(performanceChart)
                        && performanceChart.series.length > 0 && performanceChart.series[0].data.length > 0
                        && renderDetailChart(performanceChart.series, 'Performance', performanceChart.colors)}
                    {parametersArray.some((item) => CDU_Superheat.includes(item))
                        && !isUndefined(superheatChart)
                        && superheatChart.series.length > 0 && superheatChart.series[0].data.length > 0
                        && renderDetailChart(superheatChart.series, 'Superheat', superheatChart.colors)}
                </CardBody>
            </Card>
        )
    }

    const renderAirTypeMode = () => {
        const { AIR_Temp, AIR_Status, AIR_Current, AIR_RPS } = GRAPHPARAMETER

        return (
            <Card>
                <CardBody>
                    {healthScoreChart.series[0].data.length > 0
                        && renderDetailChart(healthScoreChart.series, 'Health', healthScoreChart.colors)}
                    {parametersArray.some(item => AIR_Temp.includes(item))
                        && !isUndefined(tempChart)
                        && tempChart.series[0].data.length > 0
                        && renderDetailChart(tempChart.series, 'Temp', tempChart.colors)}
                    {parametersArray.some(item => AIR_Status.includes(item))
                        && !isUndefined(statusChart)
                        && statusChart.series[0].data.length > 0
                        && renderDetailChart(statusChart.series, 'Status', statusChart.colors)}
                    {parametersArray.some(item => AIR_Current.includes(item))
                        && !isUndefined(currentChart)
                        && currentChart.series[0].data.length > 0
                        && renderDetailChart(currentChart.series, 'Current', currentChart.colors)}
                    {parametersArray.some(item => AIR_RPS.includes(item))
                        && !isUndefined(rpsChart)
                        && rpsChart.series[0].data.length > 0
                        && renderDetailChart(rpsChart.series, 'RPS', rpsChart.colors)}
                </CardBody>
            </Card>
        )
    }

    const renderMeterTypeMode = () => {
      const { METER_Current, METER_Voltage, METER_Status, METER_Energy, METER_Power } = GRAPHPARAMETER
      return (
        <Card>
          <CardBody>
            {parametersArray.some(item => METER_Status.includes(item))
              && !isUndefined(statusChart)
              && statusChart.series[0].data.length > 0
              && renderDetailChart(statusChart.series, 'Status', statusChart.colors)}
            {parametersArray.some(item => METER_Current.includes(item))
              && !isUndefined(currentChart)
              && currentChart.series[0].data.length > 0
              && renderDetailChart(currentChart.series, 'Current', currentChart.colors)}
            {parametersArray.some(item => METER_Voltage.includes(item))
              && !isUndefined(voltageChart)
              && voltageChart.series[0].data.length > 0
              && renderDetailChart(voltageChart.series, 'Voltage', voltageChart.colors)}
            {parametersArray.some(item => METER_Power.includes(item))
              && !isUndefined(powerChart)
              && powerChart.series[0].data.length > 0
              && renderDetailChart(powerChart.series, 'Power', powerChart.colors)}
            {parametersArray.some(item => METER_Energy.includes(item))
              && !isUndefined(energyChart)
              && energyChart.series[0].data.length > 0
              && renderDetailChart(energyChart.series, 'Energy', energyChart.colors)}
          </CardBody>
        </Card>
      )
    }

    const renderDetailChart = (dataSeries, type, colors) => {
        switch (type) {
            case 'Health':
                return <HealthScoreChart key={type} dataSeries={dataSeries} />
            case 'Temp':
                return <TempChart key={type} dataSeries={dataSeries} colors={colors} />
            case 'Status':
                return <StatusChart key={type} dataSeries={dataSeries} colors={colors} />
            case 'Pressure':
                return <PressureChart key={type} dataSeries={dataSeries} colors={colors} />
            case 'Current':
                return <CurrentChart key={type} dataSeries={dataSeries} colors={colors} />
            case 'Voltage':
                return <VoltageChart key={type} dataSeries={dataSeries} colors={colors} />
            case 'Power':
              return <PowerChart key={type} dataSeries={dataSeries} colors={colors} />
            case 'Energy':
              return <EnergyChart key={type} dataSeries={dataSeries} colors={colors} />
            case 'Performance':
                return <PerformanceChart key={type} dataSeries={dataSeries} colors={colors} />
            case 'Superheat':
                return <SuperheatChart key={type} dataSeries={dataSeries} colors={colors} />
            case 'RPS':
                return <RPSChart key={type} dataSeries={dataSeries} colors={colors} />
            default:
                return null
        }
    }

    if (isLoading) return <Spinner />

    return (
        <>
            {isShowCard ? renderGraph() : null}
            {
                    <Card className="mt-2">
                        <CardBody>
                            <AlertChart dataSeries={alertChart.series} totalData={totalAlert} />
                        </CardBody>
                    </Card>
            }
        </>
    )
}

export default memo(HistoricalGraph)
